export default __webpack_public_path__ + "maps-examples-map-snapshotter-thumbnail-960-1e4f6b35c1b475b4415cbe70397f16b2.png";